import { useEffect, useRef } from "react";

// Tiny event bus so the single Help dock can open the existing floating tools
// (Halle chat, Safety, Page Guide, Feedback, Voice) without rewiring their internals.
export const openTool = (id) => window.dispatchEvent(new CustomEvent("pula-tool", { detail: id }));

export function useToolOpener(id, cb) {
  const ref = useRef(cb);
  ref.current = cb;
  useEffect(() => {
    const h = (e) => { if (e.detail === id) ref.current(); };
    window.addEventListener("pula-tool", h);
    return () => window.removeEventListener("pula-tool", h);
  }, [id]);
}
